import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationDetailFragmentDoc } from '../fragments/containerStationDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerStationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetContainerStationQuery = { __typename?: 'Query', containerStation: { __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, is_recalled: boolean, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null }, store: { __typename?: 'Store', id: string, name?: string | null }, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, amount: number, image_url?: string | null, sealed: boolean }> } };


export const GetContainerStationDocument = gql`
    query GetContainerStation($id: ID!) {
  containerStation(id: $id) {
    ...ContainerStationDetail
  }
}
    ${ContainerStationDetailFragmentDoc}`;

/**
 * __useGetContainerStationQuery__
 *
 * To run a query within a React component, call `useGetContainerStationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerStationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerStationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContainerStationQuery(baseOptions: Apollo.QueryHookOptions<GetContainerStationQuery, GetContainerStationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerStationQuery, GetContainerStationQueryVariables>(GetContainerStationDocument, options);
      }
export function useGetContainerStationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerStationQuery, GetContainerStationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerStationQuery, GetContainerStationQueryVariables>(GetContainerStationDocument, options);
        }
export type GetContainerStationQueryHookResult = ReturnType<typeof useGetContainerStationQuery>;
export type GetContainerStationLazyQueryHookResult = ReturnType<typeof useGetContainerStationLazyQuery>;
export type GetContainerStationQueryResult = Apollo.QueryResult<GetContainerStationQuery, GetContainerStationQueryVariables>;